import React from 'react';
import './CourseAccordtion.css'

const courses = [
    {
        id: 'quranicReading',
        title: 'Quranic Reading (Nazira)',
        content: `
            <strong>Course Overview:</strong> The "Quranic Reading (Nazira)" course is designed specifically for beginners and those who wish to enhance their recitation of the Quran. This course provides a solid foundation in reading the Quran with proper pronunciation, also known as Tajweed. It is an essential step for anyone who desires to deepen their connection with the Quran and understand its divine message accurately.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Correct Pronunciation (Tajweed):</strong> Students will learn the rules of Tajweed, which are crucial for reading the Quran as it was revealed. This includes mastering the correct articulation of Arabic letters, understanding the nuances of elongation, and applying the rules of stopping and pausing during recitation.</li>
                <li><strong>Fluency in Reading:</strong> The course focuses on building fluency in reading the Quranic text. Through guided practice, students will improve their reading speed and accuracy, enabling them to recite with confidence.</li>
                <li><strong>Basic Quranic Vocabulary:</strong> Along with reading, students will be introduced to essential Quranic vocabulary. This will help them recognize common words and phrases, facilitating a better understanding of the text.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course is structured to be comprehensive yet accessible, with a step-by-step approach that allows students to progress at their own pace. Each session includes practical exercises and recitation practice to reinforce learning. The course is led by experienced instructors who are dedicated to helping students achieve proficiency in Quranic reading.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Beginners who are new to reading the Quran.</li>
                <li>Individuals who want to improve their Quranic recitation skills.</li>
                <li>Students who wish to lay a strong foundation in Tajweed before advancing to more complex Quranic studies.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> By the end of this course, students will have developed the ability to read the Quran fluently and with proper Tajweed. They will gain confidence in their recitation and be prepared for further studies in Quranic memorization (Hifz) or Tafseer (exegesis).
            <br><br>
            <strong>Instructor Support:</strong> Throughout the course, students will receive personalized guidance and feedback from our knowledgeable instructors. This support ensures that each student can overcome any challenges and achieve their learning goals.
        `
    },
    {
        id: 'quranicMemorization',
        title: 'Quranic Memorization (Hifz)',
        content: `
            <strong>Course Overview:</strong> The "Quranic Memorization (Hifz)" course is dedicated to helping students memorize the entire Quran. It involves systematic memorization techniques, regular review sessions, and support from qualified instructors to ensure that students successfully complete their Hifz.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Memorization Techniques:</strong> Proven methods and strategies for effective memorization of Quranic verses.</li>
                <li><strong>Review and Revision:</strong> Structured review sessions to reinforce memorized portions and improve retention.</li>
                <li><strong>Recitation Skills:</strong> Enhancing recitation skills to ensure accurate and beautiful pronunciation during memorization.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course is designed to support students through their memorization journey with scheduled memorization tasks, review sessions, and personal guidance. Each student will work closely with an instructor to track progress and overcome challenges.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals committed to memorizing the entire Quran.</li>
                <li>Students seeking to enhance their Quranic memorization skills.</li>
                <li>Those looking to strengthen their recitation and understanding of the Quran.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will achieve the memorization of the entire Quran, along with improved recitation skills and a deepened connection with the Quranic text.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will provide ongoing support, motivation, and feedback to help students successfully complete their memorization goals.
        `
    },
    {
        id: 'nooraniQaida',
        title: 'Noorani Qaida',
        content: `
            <strong>Course Overview:</strong> The "Noorani Qaida" course focuses on teaching the fundamentals of Quranic reading. It is designed for beginners to help them understand and apply the basic rules of Tajweed and improve their Quranic reading skills through structured lessons.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Arabic Phonetics:</strong> Understanding the basic sounds and pronunciation of Arabic letters.</li>
                <li><strong>Tajweed Rules:</strong> Introduction to essential Tajweed rules to improve pronunciation and reading accuracy.</li>
                <li><strong>Basic Quranic Words:</strong> Learning common Quranic words and phrases to build reading fluency.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course is organized into progressive lessons that build upon each other. Each lesson includes practice exercises, recitation drills, and teacher feedback.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Beginners who want to learn the basics of Quranic reading.</li>
                <li>Students seeking to improve their Tajweed skills.</li>
                <li>Individuals aiming to build a strong foundation for further Quranic studies.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> By the end of this course, students will have a solid understanding of Quranic phonetics and Tajweed rules, enabling them to read the Quran accurately and with proper pronunciation.
            <br><br>
            <strong>Instructor Support:</strong> Experienced instructors will provide guidance, feedback, and support throughout the course to ensure effective learning.
        `
    },
    {
        id: 'namaz',
        title: 'Namaz (Prayer)',
        content: `
            <strong>Course Overview:</strong> The "Namaz (Prayer)" course offers comprehensive instruction on the Islamic practice of prayer. This course covers the essential components of Salah, including the proper methods, timing, and spiritual significance of each prayer.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Prayer Mechanics:</strong> Detailed instruction on the physical actions and recitations involved in Salah.</li>
                <li><strong>Timing and Obligations:</strong> Understanding the timing, frequency, and obligations of the daily prayers.</li>
                <li><strong>Spiritual Benefits:</strong> Insights into the spiritual and personal benefits of performing regular prayers.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course includes practical demonstrations, guided practice, and discussions on the significance of each prayer. Students will have the opportunity to practice Salah under the guidance of experienced instructors.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals new to performing Salah.</li>
                <li>Those seeking to enhance their understanding and practice of Islamic prayer.</li>
                <li>Students who wish to deepen their spiritual connection through regular prayers.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> By the end of this course, students will have a thorough understanding of Salah and be able to perform their prayers correctly and with full awareness of their spiritual significance.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will provide ongoing support and feedback to help students perfect their prayer practice.
        `
    },
    {
        id: 'tajweed',
        title: 'Tajweed (Proper Pronunciation)',
        content: `
            <strong>Course Overview:</strong> The "Tajweed (Proper Pronunciation)" course focuses on mastering the rules of Tajweed for accurate and beautiful Quranic recitation. This course is essential for anyone who wants to improve their pronunciation and understanding of Quranic verses.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Rules of Tajweed:</strong> Detailed study of Tajweed rules, including articulation points, qualities of letters, and rules of elongation and stopping.</li>
                <li><strong>Practical Application:</strong> Practical exercises and recitation practice to apply Tajweed rules effectively.</li>
                <li><strong>Improved Recitation:</strong> Techniques to enhance the beauty and accuracy of Quranic recitation.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course includes theoretical lessons, practical exercises, and recitation drills. Students will receive personalized feedback to refine their Tajweed skills.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals seeking to improve their Quranic recitation.</li>
                <li>Students who want to master the rules of Tajweed.</li>
                <li>Anyone aiming to enhance the beauty and accuracy of their recitation.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will develop a deep understanding of Tajweed rules and be able to recite the Quran with accurate pronunciation and enhanced beauty.
            <br><br>
            <strong>Instructor Support:</strong> Qualified instructors will provide guidance and feedback to help students achieve mastery in Tajweed.
        `
    },
    {
        id: 'quranicStudies',
        title: 'Quranic Studies (Tafseer)',
        content: `
            <strong>Course Overview:</strong> The "Quranic Studies (Tafseer)" course provides an in-depth study of the meanings and interpretations of the Quranic text. This course is designed for students who wish to understand the context, teachings, and application of Quranic verses.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Quranic Exegesis:</strong> Methods and principles of Tafseer to understand the Quranic text in depth.</li>
                <li><strong>Historical Context:</strong> Insights into the historical and cultural context of Quranic revelations.</li>
                <li><strong>Application:</strong> Practical guidance on applying Quranic teachings to everyday life.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course includes lectures, discussions, and analysis of Quranic verses. Students will engage in critical thinking and apply Tafseer principles to their study of the Quran.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals interested in understanding the Quranic text more deeply.</li>
                <li>Students who wish to learn Tafseer and its applications.</li>
                <li>Those seeking to connect Quranic teachings with their daily lives.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will gain a comprehensive understanding of Quranic Tafseer and be able to interpret and apply Quranic teachings effectively.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will provide detailed explanations, guidance, and feedback throughout the course.
        `
    },
    {
        id: 'fiqh',
        title: 'Fiqh (Islamic Jurisprudence)',
        content: `
            <strong>Course Overview:</strong> The Fiqh course covers Islamic law derived from the Quran and Hadith, addressing practical aspects of worship, transactions, and personal conduct. Students gain insights into the application of Islamic principles in various aspects of daily life.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Islamic Law:</strong> Understanding the principles and application of Islamic law.</li>
                <li><strong>Practical Worship:</strong> How to implement Islamic laws in daily worship and personal conduct.</li>
                <li><strong>Transactions and Conduct:</strong> Detailed study of permissible and impermissible transactions and ethical conduct in Islam.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course is designed to provide comprehensive knowledge through lectures, discussions, and practical case studies. Students will engage in understanding the application of Islamic principles in various scenarios.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals interested in understanding Islamic law in depth.</li>
                <li>Students seeking to apply Islamic principles in their daily lives.</li>
                <li>Anyone wanting a thorough understanding of worship and transactions in Islam.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will acquire a deep understanding of Islamic jurisprudence and its application in various aspects of life.
            <br><br>
            <strong>Instructor Support:</strong> Experienced instructors will provide guidance and feedback to help students grasp complex concepts and apply them effectively.
        `
    },
    {
        id: 'hadith',
        title: 'Hadith Studies',
        content: `
            <strong>Course Overview:</strong> The Hadith Studies course examines the sayings and actions of Prophet Muhammad (PBUH) and their relevance in understanding the Quran. Students learn how Hadiths complement and elucidate Quranic teachings.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Hadith Analysis:</strong> Study of authentic Hadiths and their application in understanding Quranic verses.</li>
                <li><strong>Prophetic Teachings:</strong> How Hadiths explain and complement the teachings of the Quran.</li>
                <li><strong>Contextual Understanding:</strong> The historical and contextual background of Hadiths and their relevance to Islamic practices.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course involves detailed study and analysis of Hadith literature, discussions on their implications, and understanding their role in Islamic jurisprudence.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals interested in the sayings and actions of Prophet Muhammad (PBUH).</li>
                <li>Students looking to deepen their understanding of Hadith in relation to the Quran.</li>
                <li>Anyone seeking to gain insights into the practical application of Hadith in daily life.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will gain a comprehensive understanding of Hadiths and their role in elucidating and complementing the Quranic teachings.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will provide analysis and feedback to ensure a thorough understanding of Hadith literature.
        `
    },
    {
        id: 'seerah',
        title: 'Prophet’s Life (Seerah)',
        content: `
            <strong>Course Overview:</strong> The Seerah course provides a detailed study of the life and character of Prophet Muhammad (PBUH). It explores his interactions with the Quran and how his life exemplifies the teachings of the Quran.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Prophet’s Biography:</strong> Detailed study of the life and character of Prophet Muhammad (PBUH).</li>
                <li><strong>Interaction with the Quran:</strong> Understanding how the Prophet's life reflected and exemplified Quranic teachings.</li>
                <li><strong>Lessons and Examples:</strong> Learning from the Prophet’s actions and interactions for personal growth and understanding.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course includes lectures, readings, and discussions on the life of the Prophet (PBUH), with an emphasis on how his life serves as a model for Muslims.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals interested in the life of Prophet Muhammad (PBUH).</li>
                <li>Students looking to understand the practical application of Quranic teachings through the Prophet’s life.</li>
                <li>Anyone seeking to learn from the exemplary character and actions of the Prophet (PBUH).</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will gain an in-depth understanding of the life of Prophet Muhammad (PBUH) and how his actions and character exemplify Quranic teachings.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will provide detailed explanations and guidance to help students appreciate the significance of the Prophet’s life.
        `
    },
    {
        id: 'aqidah',
        title: 'Aqidah (Islamic Beliefs)',
        content: `
            <strong>Course Overview:</strong> Our Aqidah course covers core Islamic beliefs, including faith in Allah, Prophets, Angels, and the Hereafter. It provides students with a solid foundation in Islamic theology and understanding of key aspects of faith.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Core Beliefs:</strong> Detailed study of fundamental Islamic beliefs, including faith in Allah, Prophets, Angels, and the Hereafter.</li>
                <li><strong>Theological Foundations:</strong> Understanding the basis of Islamic theology and its impact on personal belief and practice.</li>
                <li><strong>Faith Application:</strong> How to integrate and live by these beliefs in daily life.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course is structured to provide a comprehensive understanding of Islamic beliefs through lectures, discussions, and reflective exercises.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals seeking a foundational understanding of Islamic beliefs.</li>
                <li>Students interested in deepening their knowledge of Islamic theology.</li>
                <li>Anyone wanting to solidify their faith and understanding of core Islamic principles.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will develop a strong understanding of Islamic beliefs and how to apply these principles in their lives.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will offer guidance and feedback to help students understand and integrate Islamic beliefs effectively.
        `
    },
    {
        id: 'islamicHistory',
        title: 'Islamic History',
        content: `
            <strong>Course Overview:</strong> The Islamic History course provides an overview of significant events in Islamic history and their impact on the Quranic revelations. Students gain context on the historical background that influenced the Quranic text.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Historical Events:</strong> Study of key events and periods in Islamic history and their significance.</li>
                <li><strong>Impact on the Quran:</strong> Understanding how historical contexts influenced the revelations and teachings of the Quran.</li>
                <li><strong>Contextual Understanding:</strong> Insights into the historical background that shaped Islamic teachings and practices.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course includes lectures, readings, and discussions on Islamic history, focusing on the historical context of the Quran and its revelations.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals interested in the history of Islam.</li>
                <li>Students seeking to understand the historical context of the Quran.</li>
                <li>Anyone wanting to gain insights into the events that shaped Islamic teachings.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will gain a comprehensive understanding of Islamic history and its impact on the Quranic text.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will provide detailed historical insights and context to enhance students' understanding of Islamic history.
        `
    },
    {
        id: 'islamicEthics',
        title: 'Islamic Ethics and Morality',
        content: `
            <strong>Course Overview:</strong> Our Islamic Ethics and Morality course explores principles of conduct and character based on Quranic teachings. Students learn about ethical behavior, moral values, and how to integrate these principles into their daily lives.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Ethical Principles:</strong> Study of ethical behavior and moral values derived from the Quran.</li>
                <li><strong>Moral Conduct:</strong> Understanding how to embody ethical principles in personal and social contexts.</li>
                <li><strong>Application in Daily Life:</strong> Integrating Islamic ethics into everyday actions and interactions.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course involves lectures, case studies, and discussions on ethical principles and their application in various aspects of life.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals interested in developing a strong ethical foundation based on Quranic teachings.</li>
                <li>Students looking to improve their moral conduct and understanding of Islamic ethics.</li>
                <li>Anyone seeking to apply ethical principles in their personal and professional life.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will acquire a deep understanding of Islamic ethics and how to apply moral values in their daily lives.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will offer guidance and support to help students understand and apply ethical principles effectively.
        `
    },
    {
        id: 'dua',
        title: 'Dua and Supplication',
        content: `
            <strong>Course Overview:</strong> This course focuses on the practice of Dua (supplication) in Islam. It covers various forms of Dua, their significance, and how to incorporate them into daily life for spiritual growth and connection with Allah.
            <br><br>
            <strong>What You'll Learn:</strong>
            <ul>
                <li><strong>Types of Dua:</strong> Understanding different types of supplications and their purposes.</li>
                <li><strong>Significance of Dua:</strong> Exploring the importance of Dua in Islam and its impact on personal and spiritual development.</li>
                <li><strong>Practical Application:</strong> Learning how to incorporate Dua into daily routines and special occasions.</li>
            </ul>
            <br>
            <strong>Course Structure:</strong> The course includes lectures, practical exercises, and discussions on making Dua a meaningful part of daily life.
            <br><br>
            <strong>Who Should Enroll:</strong>
            <ul>
                <li>Individuals seeking to strengthen their connection with Allah through supplication.</li>
                <li>Students interested in learning various forms of Dua and their significance.</li>
                <li>Anyone wanting to incorporate Dua into their daily routine and spiritual practice.</li>
            </ul>
            <br>
            <strong>Outcome:</strong> Students will gain a deep understanding of the practice of Dua and how to effectively incorporate it into their spiritual and daily life.
            <br><br>
            <strong>Instructor Support:</strong> Instructors will provide guidance on making Dua a meaningful practice and offer feedback on personal supplications.
        `
    },
];

const CourseAccordion = () => {
    return (
        <div>
            {/* Typewriter Heading */}
            <div className="typewriter">
                <h1>Course Contents</h1>
            </div>
            <hr/>

            {/* Accordion */}
            <div className="accordion" id="courseAccordion">
                {courses.map((course) => (
                    <div className="accordion-item" key={course.id}>
                        <h2 className="accordion-header" id={`heading${course.id}`}>
                            <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${course.id}`}
                                aria-expanded="true"
                                aria-controls={`collapse${course.id}`}
                            >
                                {course.title}
                            </button>
                        </h2>
                        <div
                            id={`collapse${course.id}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading${course.id}`}
                            data-bs-parent="#courseAccordion"
                        >
                            <div className="accordion-body" dangerouslySetInnerHTML={{ __html: course.content }} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CourseAccordion;
